const isEmptyString = function(str) {
  if (typeof str === 'string' && str !== 'undefined' && str) {
    const isBlank = /^\s*$/.test(str);
    return isBlank || str.length === 0;
  }
  return true;
};

export default isEmptyString;
